import {moment} from 'helpers';
import {format} from '../decode/convert';

export function notes(note) {
  return {
    date: note.date ? moment.unix(note.date).format(format) : null,
    isMorning: note.morning ? 1 : null,
    noteTypeId: note.categoryId || '0',
    serverId: note.id,
    tagIds: note.tagIds,
    title: note.title || '',
    type: note.category || '',
    value: note.text
  };
}
